import {ILayerQueryRequest, ILayerQueryResult, IRequestAndCancel} from "./layer_query";
import {AreaQueryService} from "./area_query";
import {MultiPolygon, Polygon} from "ol/geom";

export class OEAreaQueryService extends AreaQueryService<ILayerQueryResult> {
	queryCall(requestData: ILayerQueryRequest): IRequestAndCancel<ILayerQueryResult> {
		const geom = requestData.geometry;
		const t1 = window.performance.now();

		const result = this.layerQueryService.query(requestData);

		result.request.then(() => {
			const t2 = window.performance.now();
			let length = 0;
			let geomArea = 0;

			if (geom instanceof Polygon) {
				length = geom.getCoordinates().length;
				geomArea = geom.getArea();
			}

			if (geom instanceof MultiPolygon) {
				length = geom['flatCoordinates'].length;
				geomArea = geom.getArea();
			}
			const theResult = [geomArea, length, Math.round(t2-t1)];
			window['aq'] =  (window['aq'] || []);
			window['aq'].push(theResult);
			console.log(theResult);
			// console.log(`${Math.round(geomArea / (t2-t1))} square metre per ms`);
		});

		return result;
	}
}